module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filters"
  }, [_c('dropdown-select', {
    attrs: {
      "options": _vm.sort_options,
      "selected": _vm.sort_filter
    },
    on: {
      "input": _vm.filter
    },
    model: {
      value: (_vm.sort_filter),
      callback: function($$v) {
        _vm.sort_filter = $$v
      },
      expression: "sort_filter"
    }
  }), (_vm.show_user_filter) ? _c('dropdown-select', {
    attrs: {
      "options": _vm.users_options,
      "selected": _vm.user_filter
    },
    on: {
      "input": _vm.filter
    },
    model: {
      value: (_vm.user_filter),
      callback: function($$v) {
        _vm.user_filter = $$v
      },
      expression: "user_filter"
    }
  }) : _vm._e(), _c('div', {
    staticClass: "search-field-wrapper"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-search glyphicon glyphicon-search",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.filter
    }
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text_field_filter),
      expression: "text_field_filter"
    }],
    staticClass: "search-field form-control",
    attrs: {
      "placeholder": _vm.$t('flows.actions.find'),
      "type": "text"
    },
    domProps: {
      "value": (_vm.text_field_filter)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filter.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text_field_filter = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "clear"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f60cf2d6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/flows/filters.vue
// module id = 1233
// module chunks = 1